import React from "react";
import { Button } from "antd";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { DownloadOutlined } from "@ant-design/icons";
// import "./styles.css";

export default class XslxGen extends React.Component {
    exportToCSV = () => {
        const { csvData, fileName } = this.props;
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    };

    render() {
        return (
            <Button
                className="userButton"
                onClick={(e) => this.exportToCSV()}
            >
                Download
                <DownloadOutlined
                    style={{
                        fontSize: "16px",
                        verticalAlign: "top",
                    }}
                />
            </Button>
        );
    }
}
